import { Flex, FlexProps, Icon, Text, TextProps } from "@chakra-ui/react";
import { FaWhatsapp } from "react-icons/fa";
import { WhatsAppSendKind, whatsappSentText } from "utils/whatsapp";
import { WHATSAPP_GREEN } from "./WhatsAppOptIn";

export interface WhatsAppSentNoteProps extends FlexProps {
  kind: WhatsAppSendKind;
  /** The number the checkout sent, as the customer typed it (spaces and dashes removed). */
  number: string;
  textProps?: TextProps;
}

/**
 * "Your ticket is on its way to WhatsApp (9841000000)" on the success page,
 * when the checkout asked for it (claude/design/whatsapp-messaging/04 §3).
 * The full number, as pvapp shows it.
 */
function WhatsAppSentNote({
  kind,
  number,
  textProps,
  ...props
}: WhatsAppSentNoteProps) {
  return (
    <Flex
      data-testid="whatsapp-sent-note"
      align="center"
      gap="0.5rem"
      px="1rem"
      py="0.75rem"
      borderWidth="1px"
      borderRadius="md"
      borderColor="green.400"
      fontSize="sm"
      {...props}
    >
      <Icon
        as={FaWhatsapp}
        boxSize="1.25rem"
        color={WHATSAPP_GREEN}
        flexShrink={0}
        aria-hidden
      />
      <Text lineHeight="1.5" {...textProps}>
        {whatsappSentText(kind, number)}
      </Text>
    </Flex>
  );
}

export default WhatsAppSentNote;
